import React, { useId } from "react";
import { Link } from "react-router-dom";

export default function DynamicCorporateTeamSection({ data }) {
  const titleId = useId();

  if (!data) return null;

  return (
    <section className="dynamic-corporate-team-section" aria-labelledby={titleId}>
      <div className="container">
        <div className="row align-items-center dynamic-corporate-team-row">
          <div className="col-lg-6">
            <img className="dynamic-corporate-team-image" src={data.image} alt={data.imageAlt} width="754" height="944" loading="lazy" />
          </div>
          <div className="col-lg-6">
            <div className="dynamic-corporate-team-content">
              <span className="main-title">{data.eyebrow}</span>
              <h2 className="heading" id={titleId}>{data.title}</h2>
              <p className="dynamic-corporate-team-description">{data.description}</p>
              <ul className="dynamic-corporate-team-options">
                {data.items.map((item) => <li key={item}>{item}</li>)}
              </ul>
              <div className="dynamic-corporate-team-actions">
                <a className="default-btn" href={data.buttonLink}>{data.buttonText}</a>
                <Link className="dynamic-corporate-team-link" to={data.secondaryLink}>{data.secondaryButtonText}</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
